import React from 'react';
import { dispatcher } from 'dispatcher';

import { InputReg } from '@interlayer/js/app/components/main/Registration/components/common/InputReg';

import { TInputRegProps } from '@interlayer/js/app/components/main/Registration/components/common/InputReg/types';
import { ON_BLUR_EMAIL_FIELD, ON_FOCUS_EMAIL_FIELD } from '@interlayer/js/app/components/main/Registration/constants';
import { VALIDATION_FIELDS } from '@interlayer/js/app/hooks/useValidationRules/constants';

export const EmailJoinField: React.FC<Partial<TInputRegProps>> = (props) => {
    const handlerOnFocus = () => {
        dispatcher.dispatch(ON_FOCUS_EMAIL_FIELD);
    };

    const handlerOnBlur = () => {
        dispatcher.dispatch(ON_BLUR_EMAIL_FIELD);
    };

    return (
        <InputReg
            type="email"
            name={VALIDATION_FIELDS.email}
            onFocus={handlerOnFocus}
            onBlur={handlerOnBlur}
            {...props}
        />
    );
};
